<template>
  <el-table-column
    prop="id"
    label="#"
    fixed
    width="70"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      {{ scope.row.id }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'id',
  };
</script>
